import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemText
} from "../../report-design-item";

@Pipe({
  name: "asTextConfig",
  standalone: false
})
export class ReportItemConfigAsTextPipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemText {
    return <ReportDesignItemText>value;
  }
}
